import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from '@hausgold/designsystem';
import { jsx } from '@emotion/react';
var _excluded = ["children"];
var Layout = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return jsx(Fragment, null, jsx(Flex
  // Note: Height chances on this place will break iframes as the ref is linking to the inner element,
  //   so extra height space will result in cutting of content.
  //  The `ref` itself can't be attached here because flex as not an absolute height value
  //  which can be taken - so it is nested.
  , _extends({
    className: "layout",
    height: "100%",
    alignItems: "center",
    justifyContent: "center"
  }, props), jsx(Box, {
    ref: ref,
    className: "main",
    width: "100%",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: "blue.400",
    borderRadius: 10
  }, jsx("div", null, children))));
});
Layout.propTypes = {
  children: PropTypes.node
};
Layout.defaultProps = {
  children: null
};
export { Layout as default };